import React, { Component } from 'react';

import { TextField, IconButton } from "@material-ui/core";

import { Card, } from '@material-ui/core';

import Button from '@material-ui/core/Button'


// import Visibility from '@material-ui/icons/Visibility'

// import VisibilityOff from '@material-ui/icons/VisibilityOff'

// import Form from 'react-bootstrap/Form'

// import InputAdornment from '@material-ui/core/InputAdornment';

import Snackbar from '@material-ui/core/Snackbar';

import CloseIcon from '@material-ui/icons/Close'


import '../../App.css'

import { userRegister } from '../../services/userServices';




export default class Signup extends Component {


    constructor() {
        super();
        this.state = {
            showPassword: false,
            fields: {},
            errors: {},
            snackBarMessage: ""
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    /**
     * @description: To take details of the user
     * @param {event} e
     */
    handleChange(e) {
        try {
            let fields = this.state.fields;
            fields[e.target.name] = e.target.value;
            this.setState({ fields });
            this.setState({ [e.target.name]: e.target.value });
        } catch (err) {
            console.log("error in login handleChange");
        }
    }
    handleSubmit = e => {
        e.preventDefault();
        if (!this.validateForm()) {
            let fields = {};
            fields["firstName"] = this.state.fields.firstName;
            fields["lastName"] = this.state.fields.lastName;
            fields["email"] = this.state.fields.email;
            fields["password"] = this.state.fields.password;

            fields["contactNo"] = this.state.fields.phoneNo;

            this.setState({ fields: fields });
            var data = {
                firstName: this.state.fields.firstName,
                lastName: this.state.fields.lastName,
                email: this.state.fields.email,
                password: this.state.fields.password,
                phone: this.state.fields.phoneNo
            };
            this.setState({
                openSnackBar: true,
                snackBarMessage: "Registration Successful"
            });


            userRegister(data)
                .then((response) => {
                    console.log("response", response);
                    setTimeout(() => {
                        this.RedirectUser();
                    }, 500);
                })
                .catch(err => {
                    console.log(err);
                    this.setState({
                        openSnackBar: true,
                        snackBarMessage: "Registration failed"
                    });
                });
        }
    };

    /**
     * @description: To send all the details of the user to database, if it's valid
     */
    RedirectUser() {
        this.props.history.push("/login");
    }

    /**
     *@description: To display/hide the password to the user
     */
    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };
    /**
     *@description: To close the snack bar
     */
    handleSnackClose = () => {
        try {
            this.setState({
                openSnackBar: false
            });
        } catch (err) {
            console.log("error at handleSnackClose in login");
        }
    };
    /**
     * @description:To redirect user to login page
     */
    loginclick = event => {
        try {
            event.preventDefault();
            this.props.history.push("/login");
        } catch (err) {
            console.log("error at login click in registration");
        }
    };

    /**
     * @description: To perform validations
     */
    validateForm() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "*Please enter your email-ID.";
        }

        if (!fields["lastName"]) {
            formIsValid = false;
            errors["lname"] = "*LastName cant'be empty.";
        }
        if (!fields["firstName"]) {
            formIsValid = false;
            errors["fname"] = "*FirstName cant'be empty.";
        }
        if (typeof fields["firstName"] !== "undefined") {
            if (!fields["firstName"].match(/^.*(?=.{3,}).*$/)) {
                formIsValid = false;
                errors["name"] = "*FirstName must contain minimum three characters.";
            }
        }



        if (!fields["contactNo"]) {
            formIsValid = false;
            errors['contactNo'] = "Contact number should not be empty"
        }


        if (!/^\d{10}$/.test(this.state.contactNo)) {
            formIsValid = false
            errors["contactNo"] = "enter 10 digits only"
        }

        // if(!fields['contactNo'].match(/^[0-9]*$/){
        //     formIsValid=false;
        //     errors["contactNo"]="enter 10 digit number";
        // }





        if (!fields["password"]) {
            formIsValid = false;
            errors["password"] = "*Please enter the password.";
        }
        if (!fields["confirmPassword"]) {
            formIsValid = false;
            errors["password"] = "*Please enter the password.";
        }
        if (fields["confirmPassword"] !== fields["password"]) {
            formIsValid = false;
            errors["password"] = "*Passwords doesn't match";
        }

        if (typeof fields["password"] !== "undefined") {
            // if (!fields["password"].match(/^.*(?=.{6,}).*$/)) {
            if (!fields['password'].match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/)) {
                formIsValid = false;
                errors["password"] = "*Password must contain 6 characters in which 1 Capital,special character & lower case ..";
            }
        }
        this.setState({
            errors: errors
        });
        return formIsValid;
    }



    render() {

        return (
            <div>
                {/* <Card className="Card">
                    <div className="content"> */}


                <Card id="CardR" className="CardR">


                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>


                        <div id="TitleBarR"> ChromaFan </div>

                        {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                            <div>
                                <p style={{ fontSize: 15 }}>Already have an Account?</p>
                            </div>

                            <div>
                                <Button
                                    style={{ fontSize: 15, fontWeight: 'bold', marginBottom: '20px' }}
                                    color="primary"
                                    id="LinkButton"
                                    title="Click to register"
                                    onClick={this.loginclick}>
                                    Log In.
                                     </Button>
                            </div>

                        </div> */}

                    </div>




                    <form onSubmit={this.handleSubmit}>
                        <div class="form-row">
                            <div class="col">

                                {/* <form onSubmit={this.handleSubmit}> */}

                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-evenly" }}>
                                    <div className="fname">
                                        <TextField
                                            type="text"
                                            label="First Name"
                                            id="firstName"
                                            name="firstName"
                                            className="outlined-names"
                                            margin="normal"
                                            variant="outlined"
                                            value={this.state.fields.firstName}
                                            onChange={this.handleChange}
                                        />
                                        <div className="errorMsgF">{this.state.errors.fname}</div>
                                    </div>
                                </div>
                            </div>


                            <div class="col">

                                <div className="lname">
                                    <TextField
                                        type="text"
                                        label="Last Name"
                                        id="lastName"
                                        name="lastName"
                                        className="outlined-names"
                                        margin="normal"
                                        variant="outlined"
                                        value={this.state.fields.lastName}
                                        onChange={this.handleChange}
                                    />
                                    <div className="errorMsgF">{this.state.errors.lname}</div>
                                </div>


                            </div>
                        </div>
                    </form>


                    <form onSubmit={this.handleSubmit}>
                        <div class="form-row">
                            <div class="col">


                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-evenly" }}>
                                    <div className="fname">
                                        <TextField
                                            type="text"
                                            label="Email-Id"
                                            // id="firstName"
                                            // name="firstName"
                                            className="outlined-names"
                                            margin="normal"
                                            variant="outlined"
                                            value={this.state.fields.email}
                                            onChange={this.handleChange}
                                        />
                                        <div className="errorMsgF">{this.state.errors.email}</div>
                                    </div>
                                </div>



                            </div>

                            <div class="col">


                                <div className="phoneNo">
                                    <TextField
                                        type='phonNo'
                                        label='Phone Number'
                                        id='phoneNo'
                                        name="phoneNo"
                                        margin="normal"
                                        variant="outlined"
                                        value={this.state.fields.contactNo}
                                        // style={{ width: '100%' }}
                                        onChange={this.handleChange}
                                    />
                                    {/* <div className="errorMsgF"> {this.state.errors.contactNo} </div> */}
                                </div>


                            </div>
                        </div>
                    </form>





                    <form onSubmit={this.handleSubmit}>
                        <div class="form-row">
                            <div class="col">

                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-evenly" }}>
                                    <div className="fname">

                                        <TextField
                                            id="outlined-password-input"
                                            label="Password"
                                            // className={classes.textField}
                                            type="password"
                                            autoComplete="current-password"
                                            margin="normal"
                                            variant="outlined"
                                        />

                                        {/* <TextField
                                            id="outlined-adornment-password"
                                            // className={clsx(classes.margin, classes.textField)}
                                            className="outlined-names"
                                            variant="outlined"
                                            // type={values.showPassword ? 'text' : 'password'}
                                            type={this.state.showPassword ? "text" : "password"}
                                            label="Password"
                                            // value={values.password}
                                            // onChange={handleChange('password')}
                                            value={this.state.fields.confirmPassword}
                                            onChange={this.handleChange}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            style={{ outline: 'none' }}
                                                            edge="end"
                                                            aria-label="Toggle password visibility"
                                                            // onClick={handleClickShowPassword}
                                                            onClick={this.handleClickShowPassword}
                                                        >
                                                            {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        /> */}


                                    </div>
                                </div>


                            </div>




                            <div class="col">




                                <div className="lname">

                                    <TextField
                                        id="outlined-password-input"
                                        label="Confirm Password"
                                        // className={classes.textField}
                                        type="password"
                                        autoComplete="current-password"
                                        margin="normal"
                                        variant="outlined"
                                    />



                                    {/* <TextField
                                        id="outlined-adornment-password"
                                        // className={clsx(classes.margin, classes.textField)}
                                        className="outlined-names"
                                        variant="outlined"
                                        // type={values.showPassword ? 'text' : 'password'}
                                        type={this.state.showPassword ? "text" : "password"}
                                        label="Confirm Password"
                                        // value={values.password}
                                        // onChange={handleChange('password')}
                                        value={this.state.fields.confirmPassword}
                                        onChange={this.handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        style={{ outline: 'none' }}
                                                        edge="end"
                                                        aria-label="Toggle password visibility"
                                                        // onClick={handleClickShowPassword}
                                                        onClick={this.handleClickShowPassword}
                                                    >
                                                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    /> */}


                                    {/* <div className="toggle">
                                    <IconButton
                                        id="toggle"
                                        aria-label="Toggle password visibility"
                                        onClick={this.handleClickShowPassword}
                                    >
                                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </div> */}


                                </div>

                            </div>

                        </div>


                        <div className="errorMsgF" style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-evenly" }}>{this.state.errors.password}  </div>


                        <div style={{ textAlign: 'center', margin: '5%' }}>
                            <Button type="submit"
                                style={{ width: '50%', }}
                                id='button12'
                                title="Sign-up"> Sign-up</Button>
                                
                        </div>



                    </form>








                    {/* </div> */}
                    {/* // </Card>  */}


                </Card>

                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                    open={this.state.openSnackBar}
                    autoHideDuration={6000}
                    onClose={this.handleSnackClose}
                    variant="error"
                    ContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id"> {this.state.snackBarMessage} </span>}
                    action={[
                        <div>
                            <IconButton
                                key="close"
                                aria-label="Close"
                                onClick={this.handleSnackClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                    ]}
                />






            </div>

        )
    }
}




//    {/* <TextField
//                                             // type="text"
//                                             // label="First Name"
//                                             // id="firstName"
//                                             // name="firstName"
//                                             className="outlined-names"
//                                             margin="normal"
//                                             variant="outlined"

//                                             // onChange={this.handleChange}



//                                             // className="outlined-adornment-passwords"
//                                             // variant="outlined"
//                                             // id="password"
//                                             // name="password"
//                                             value={this.state.fields.password}
//                                             onChange={this.handleChange}
//                                             type={this.state.showPassword ? "text" : "password"}
//                                             label="Password"
//                                         /> */}




// {/* <div className="lname">
//                                 <TextField

//                                     // type="text"
//                                     // label="Email-Id"
//                                     // id="firstName"
//                                     // name="firstName"
//                                     className="outlined-names"
//                                     margin="normal"
//                                     variant="outlined"
//                                     // value={this.state.fields.email}
//                                     // onChange={this.handleChange}


//                                 // className="outlined-adornment-passwords"
//                                 // variant="outlined"
//                                 // id="confirm"
//                                 // name="confirmPassword"
//                                 value={this.state.fields.confirmPassword}
//                                 onChange={this.handleChange}
//                                 type={this.state.showPassword ? "text" : "password"}
//                                 label="Confirm Password" 

//                                  /> */}




